<template>
  <footer class="app-footer">
    <!-- 主链接区 -->
    <div class="footer-main">
      <div class="container footer-grid">
        <!-- 关于 -->
        <div class="footer-col footer-about">
          <div class="footer-logo">
            <div class="footer-logo-icon">
              <a-icon type="experiment" />
            </div>
            <span>QD FTZ Chemical</span>
          </div>
          <p class="footer-desc">{{ $t('footer.about') }}</p>
          <div class="footer-social">
            <a href="#" title="WeChat"><a-icon type="wechat" /></a>
            <a href="#" title="LinkedIn"><a-icon type="linkedin" /></a>
            <a href="#" title="Email"><a-icon type="mail" /></a>
          </div>
        </div>

        <!-- 快速链接 -->
        <div class="footer-col">
          <h4>{{ $t('footer.quickLinks') }}</h4>
          <ul>
            <li><router-link to="/">{{ $t('nav.home') }}</router-link></li>
            <li><router-link to="/products">{{ $t('nav.products') }}</router-link></li>
            <li><router-link to="/about">{{ $t('nav.about') }}</router-link></li>
            <li><router-link to="/contact">{{ $t('nav.contact') }}</router-link></li>
          </ul>
        </div>

        <!-- 产品分类 -->
        <div class="footer-col">
          <h4>{{ $t('footer.products') }}</h4>
          <ul>
            <li v-for="cat in categories" :key="cat.key">
              <router-link :to="`/products?category=${cat.key}`">
                {{ locale === 'zh' ? cat.nameZh : cat.name }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- 联系方式 -->
        <div class="footer-col">
          <h4>{{ $t('footer.contactInfo') }}</h4>
          <ul class="contact-list">
            <li>
              <a-icon type="phone" />
              <span>{{ contact.phone }}</span>
            </li>
            <li>
              <a-icon type="mail" />
              <span>{{ contact.email }}</span>
            </li>
            <li>
              <a-icon type="environment" />
              <span>{{ locale === 'zh' ? contact.addressZh : contact.address }}</span>
            </li>
            <li>
              <a-icon type="clock-circle" />
              <span>{{ locale === 'zh' ? contact.workingHoursZh : contact.workingHours }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 底部栏 -->
    <div class="footer-bottom">
      <div class="container footer-bottom-inner">
        <span>{{ $t('footer.copyright') }}</span>
        <span class="footer-links">
          <a href="#">{{ $t('footer.privacy') }}</a>
          <a href="#">{{ $t('footer.terms') }}</a>
          <span>{{ $t('footer.icp') }}</span>
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    locale() {
      return this.$store.locale
    },
    categories() {
      return this.$store.categories
    },
    contact() {
      return this.$store.contact
    }
  },
}
</script>

<style lang="less" scoped>
@import '../../styles/variables.less';

.app-footer {
  background: @primary-dark;
  color: #fff;
  margin-top: auto;
}

// 主链接区
.footer-main {
  padding: 60px 0 40px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
  gap: 40px;

  @media @tablet {
    grid-template-columns: 1fr 1fr;
  }

  @media @mobile {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;

  &-icon {
    width: 36px;
    height: 36px;
    background: @accent-teal;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #fff;
  }

  span {
    font-size: 18px;
    font-weight: 700;
  }
}

.footer-desc {
  color: rgba(255, 255, 255, 0.55);
  font-size: 13px;
  line-height: 1.8;
  margin-bottom: 20px;
}

.footer-social {
  display: flex;
  gap: 12px;

  a {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.7);
    font-size: 16px;
    transition: all @duration-fast @ease-professional;

    &:hover {
      background: @accent-teal;
      color: #fff;
      transform: translateY(-2px);
    }
  }
}

.footer-col {
  h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #fff;
    position: relative;
    padding-bottom: 12px;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 30px;
      height: 2px;
      background: @accent-teal;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 10px;

    a {
      color: rgba(255, 255, 255, 0.55);
      font-size: 13px;
      transition: all @duration-fast @ease-professional;

      &:hover {
        color: @accent-teal;
        padding-left: 4px;
      }
    }
  }
}

.contact-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: rgba(255, 255, 255, 0.55);
  font-size: 13px;

  .anticon {
    margin-top: 3px;
    color: @accent-teal;
  }
}

// 底部栏
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 20px 0;
}

.footer-bottom-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;

  @media @mobile {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
}

.footer-links {
  display: flex;
  gap: 16px;

  a {
    color: rgba(255, 255, 255, 0.4);

    &:hover {
      color: @accent-teal;
    }
  }
}
</style>
